import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../lib/api";

const LOGO_URL = "/ab-microplay-logo.png";

export default function Layout({ children, hideHeader = false }) {
  const loc = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let active = true;
    const fetchStatus = () => {
      api.get("/store/status")
        .then((r) => { if (active) setIsOpen(!!r.data.is_open); })
        .catch(() => {});
    };
    fetchStatus();
    const intervalId = setInterval(fetchStatus, 30000);
    const onFocus = () => fetchStatus();
    window.addEventListener("focus", onFocus);
    return () => { active = false; clearInterval(intervalId); window.removeEventListener("focus", onFocus); };
  }, []);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--ab-bg)" }}>
      {!hideHeader && (
        <header
          className="border-b sticky top-0 z-30"
          style={{
            backdropFilter: "blur(20px)",
            background: "rgba(10,10,10,0.8)",
            borderColor: "var(--ab-border)",
          }}
          data-testid="ab-header"
        >
          <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="ab-header-logo">
              <img src={LOGO_URL} alt="AB Microplay" className="h-10 sm:h-12 w-auto" style={{ imageRendering: "auto" }} />
            </Link>

            {isOpen && (
              <div className="flex-1 flex justify-center min-w-0">
                <span className="open-now-badge fade-in" data-testid="open-now-badge">
                  <span className="open-now-dot" />
                  Open Now
                </span>
              </div>
            )}

            <nav className="hidden md:flex gap-6 label-eyebrow shrink-0">
              <Link to="/quote" className={loc.pathname.startsWith("/quote") ? "text-white" : ""}>Quote</Link>
              <Link to="/inventory-lookup" className={loc.pathname.startsWith("/inventory-lookup") ? "text-white" : ""}>Lookup</Link>
              <Link to="/account-lookup" className={loc.pathname.startsWith("/account-lookup") ? "text-white" : ""}>Member</Link>
            </nav>
          </div>
        </header>
      )}
      <main className="flex-1">{children}</main>
      <footer className="border-t mt-12" style={{ borderColor: "var(--ab-border)" }}>
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row justify-between gap-2 label-eyebrow">
          <span>AB MICROPLAY &middot; The Garage Gaming Store</span>
          <div className="flex items-center gap-4">
            <Link to="/pos" className="hover:text-white transition-colors opacity-60 hover:opacity-100" data-testid="footer-pos-link">POS</Link>
            <span>v1.0</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
